<template>
    <div id="analyze">
        <div style="height: 120px;border-bottom: 2px dashed #eee">
            <el-row>
                <el-col>
                    <span class="demonstration" style="border-radius: 5px;margin-right: 15px">月份</span>
                    <el-date-picker
                            @click.native="typeChange"
                            style="width: 160px;margin-right: 50px"
                            v-model="dateValue"
                            type="month"
                            placeholder="选择月份">
                    </el-date-picker>

                    <div style="float: right">
                        <span style="margin-right: 15px">人员</span>
                        <inputSelect :handleSelectInput="handleSelectInputClick"></inputSelect>
                    </div>
                </el-col>
                <el-col span="24" style="margin-top: 24px">
                    <el-button type="primary" size="small" @click="searchWeekList"
                               style="background: #4EC880;border: none">
                        查询
                    </el-button>
                    <el-button type="danger" size="small" @click="ResetClick"
                               style="background: #D0021B;border: none">
                        重置
                    </el-button>
                </el-col>
            </el-row>
        </div>
        <el-row  style="margin-top: 20px">
            <el-col span="24">
                 <span style="vertical-align:middle;font-size: 17px">
                    2019年9月
                </span>
                <span style="font-size: 12px;margin-left: 10px;color:#FF9901;vertical-align:middle">
                    目标客户 155人
                </span>
                <span style="font-size: 12px;margin-left: 10px;color: #4A90E2;vertical-align:middle">
                    辖区内共有328名HCP
                </span>
            </el-col>
            <el-col span="7">
                <ul style="height: 100%;margin-top: 10px;margin-right: 0">
                    <li class="li" >
                        <span class="li_span" style="vertical-align: bottom">
                            辖区机构数
                        </span>
                        <span class="li_spanR" style="vertical-align: bottom">
                            8家
                        </span>
                    </li>
                    <li class="li">
                         <span class="li_span" style="vertical-align: bottom">
                            覆盖机构数
                        </span>
                        <span class="li_spanR" style="vertical-align: bottom">
                            5家
                        </span>
                    </li>
                    <li class="li">
                         <span class="li_span" style="vertical-align: middle">
                            机构覆盖率
                        </span>
                        <div style="display: inline-block;width:calc(100% - 80px) ">
                            <el-rate
                                    low-threshold="6"
                                    high-threshold="9"
                                    style="width:calc(100% - 80px);display: inline-block"
                                    disabled
                                    v-model="value4"
                                    :max="max"
                                    disabled-void-color="#9B9B9B"
                                    disabled-void-icon-class="iconfont_Add icon-shixinzhengfangxing"
                                    :iconClasses="iconClasses"
                                    void-color="#9B9B9B"
                                    void-icon-class="iconfont_Add icon-shixinzhengfangxing"
                                    :colors="colors"
                            >
                            </el-rate>
                            <span
                                    style="vertical-align: middle;font-size: 12px;color: #ff9901"
                            >
                                {{parseInt(value4) * 10 + "%" }}</span>
                        </div>

                    </li>
                    <li class="li">
                         <span class="li_span" style="vertical-align: bottom">
                            计划协访数
                        </span>
                        <span class="li_spanR" style="vertical-align: bottom">
                            3次
                        </span>
                    </li>
                    <li class="li">
                         <span class="li_span" style="vertical-align: bottom">
                            实际协访数
                        </span>
                        <span class="li_spanR" style="vertical-align: bottom">
                            2次
                        </span>
                    </li>
                    <li class="li">
                         <span class="li_span" style="vertical-align: bottom">
                            协访时长
                        </span>
                        <span class="li_spanR" style="vertical-align: bottom">
                            6小时
                        </span>
                    </li>
                </ul>
            </el-col>
            <el-col span="1" style="border: 1px transparent solid;" v-show="owenr_id === '' || owenr_id === '0'">
                <div style="height: 100px;border: 1px solid #bbbbbb;width: 0px;margin: 50px auto">
                </div>
            </el-col>
            <el-col :span="7" style="" v-show="owenr_id === '' || owenr_id === '0'">
                <div id="analyze_room_one" style="width:100%;height:250px;"></div>
            </el-col>
            <el-col span="1" style="border: 1px transparent solid;">
                <div style="height: 100px;border: 1px solid #bbbbbb;width: 0px;margin: 50px auto">
                </div>
            </el-col>
            <el-col :span="7" style="">
                <div id="analyze_room_two" style="width:100%;height: 300px;"></div>
            </el-col>
            <el-col span="24" style="margin-top: 20px">
                <el-row >
                    <el-col span="7" style="text-align: center;color: #3998f7">数据汇总</el-col>
                    <el-col span="1" style="border: 1px transparent solid;" v-show="owenr_id === '' || owenr_id === '0'"></el-col>
                    <el-col span="7" style="text-align: center;color: #3998f7" v-show="owenr_id === '' || owenr_id ===
                    '0'">下属协访情况</el-col>
                    <el-col span="1" style="border: 1px transparent solid;"></el-col>
                    <el-col span="7" style="text-align: center;color: #3998f7">协访反馈对比</el-col>
                </el-row>
            </el-col>

        </el-row>

        <el-row style="margin-top: 20px">
            <el-table
                    :data="tableData"
                    style="width: 100%">
                <el-table-column
                        prop="date"
                        label="日期"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="协访人"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="address"
                        label="被协访人"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="协访类型">
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="协访客户数">
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="协访时长">
                </el-table-column>
                <el-table-column
                        prop="address"
                        sortable
                        label="是否计划内协访">
                </el-table-column>
            </el-table>
        </el-row>
    </div>
</template>

<script>
    import inputSelect from '../../../calendar/components/components/inputSelect'
    export default {
        name: "institution",
        data(){
            return {
                form:{},
                tableData: [{
                    date: '王晓云',
                    name: '4',
                    address: '-'
                }, {
                    date: '王晓云',
                    name: '3',
                    address: '-'
                }, {
                    date: '王晓云',
                    name: '2',
                    address: '-'
                }, {
                    date: '王晓云',
                    name: '2',
                    address: '-'
                }],
                onoff:false,
                roomChart:'',
                gradeChart:'',
                threeChart:'',
                max:10,
                // value:6.7,
                // iconClasses: [divGreen, divGreen, divGreen],
                value1: 10,
                value2: 8.3,
                value3: 10,
                value4: 6.2,
                iconClasses: ['iconfont_Add icon-shixinzhengfangxing', 'iconfont_Add icon-shixinzhengfangxing',
                    'iconfont_Add icon-shixinzhengfangxing',
                    'iconfont_Add icon-shixinzhengfangxing', 'iconfont_Add icon-shixinzhengfangxing',
                    'iconfont_Add icon-shixinzhengfangxing',
                    'iconfont_Add icon-shixinzhengfangxing', 'iconfont_Add icon-shixinzhengfangxing',
                    'iconfont_Add icon-shixinzhengfangxing',
                    'iconfont_Add icon-shixinzhengfangxing'],
                colors:['#ED3B3F','#FF9901','#7ED321'],
                dateValue2:'',
                dateValue:'',
                owenr_id:this.GLOBAL.selectPeople_global,
            }
        },
        components:{
            inputSelect
        },
        mounted(){
            this.init()

            window.onresize = () => {
                this.roomChart.resize()
                this.gradeChart.resize()
            }
        },
        methods:{
            init(){

                this.roomChart=this.$echarts.init(document.getElementById('analyze_room_two'));
                this.gradeChart=this.$echarts.init(document.getElementById('analyze_room_one'));
               let option = {
                    title: {
                        text: ''
                    },
                    tooltip: {},
                    legend: {
                        data: ['上月第一次', '本月第一次'],
                        align:"left",
                        orient:"horizontal",
                        bottom:'0'
                    },
                    radar: {
                        // shape: 'circle',
                        name: {
                            textStyle: {
                                color: '#fff',
                                backgroundColor: '#999',
                                borderRadius: 3,
                                padding: [3, 5]
                            }
                        },
                        indicator: [
                            { name: '协访前', max: 6500},
                            { name: '协访总结', max: 16000},
                            { name: '缔结', max: 30000},
                            { name: '异议处理', max: 38000},
                            { name: '介绍', max: 52000},
                            { name: '探寻', max: 25000},
                            { name: '开场白', max: 25000}
                        ]
                    },
                    series: [{
                        name: '',
                        type: 'radar',
                        // areaStyle: {normal: {}},
                        data: [
                            {
                                value: [4300, 10000, 28000, 35000, 50000, 19000],
                                name: '上月第一次'
                            },
                            {
                                value: [5000, 14000, 28000, 31000, 42000, 21000],
                                name: '本月第一次'
                            }
                        ]
                    }]
                };
               let option3 = {
                    tooltip: {
                        trigger: 'axis',

                    },
                    toolbox: {
                        feature: {
                            dataView: {show: true, readOnly: false},
                            magicType: {show: true, type: ['line', 'bar']},
                            restore: {show: true},
                            saveAsImage: {show: true}
                        }
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: ['张三', '李四', '王五', '赵六'],
                            axisPointer: {
                                type: 'shadow'
                            },
                            axisLine:{					//---坐标轴 轴线
                                show:true,					//---是否显示

                                //------------------- 箭头 -------------------------
                                symbol:['none', 'none'],	//---是否显示轴线箭头
                                symbolSize:[8, 8] ,			//---箭头大小
                                symbolOffset:[0,7],			//---箭头位置

                                //------------------- 线 -------------------------
                                lineStyle:{
                                    color:'#9D9D9D',
                                    width:1,
                                    type:'solid',
                                },
                            },
                            axisTick:{					//---坐标轴 刻度
                                show:false,					//---是否显示
                                inside:true,				//---是否朝内
                                lengt:5,					//---长度
                                lineStyle:{
                                    //color:'red',			//---默认取轴线的颜色
                                    width:1,
                                    type:'solid',
                                },
                            },
                            axisLabel:{					//---坐标轴 标签
                                show:true,					//---是否显示
                                inside:false,				//---是否朝内
                                rotate:0,					//---旋转角度
                                margin: 5,					//---刻度标签与轴线之间的距离
                                //color:'red',				//---默认取轴线的颜色
                            },
                            splitLine:{					//---grid 区域中的分隔线
                                show:false,					//---是否显示，'category'类目轴不显示，此时我的X轴为类目轴，splitLine属性是无意义的
                                lineStyle:{
                                    color:'#9D9D9D',
                                    width:1,
                                    type:'solid',
                                },
                            },
                        }

                    ],
                    yAxis: {show:false},
                    series: [
                        {
                            name: '计划协访',
                            type: 'bar',
                            data: [20, 49, 70, 22],
                            itemStyle:{
                                color:"#5B8FF9"
                            }
                        },
                        {
                            name: '计划协访',
                            type: 'bar',
                            data: [26, 59, 90, 24],
                            itemStyle:{
                                color:"#5AD8A6"
                            }
                        },

                    ]
                };


                this.roomChart.setOption(option)
                this.gradeChart.setOption(option3)
            },
            handleSelectInputClick(j){
                this.owenr_id = j
            },
            typeChange(){
                if (this.onoff){
                    this.onoff = false
                    this.$nextTick( ()=>{
                        // this.init()
                        //
                        // window.onresize = () => {
                        //     this.roomChart.resize()
                        //     this.gradeChart.resize()
                        // }
                    })
                } else {
                    // this.roomChart.clear()
                    // this.gradeChart.clear()
                    this.onoff = true
                }


            }

        }
    }
</script>

<style scoped>
    #analyze .custDiv_border:before{
        content:" ";
        height: 100px;
        border: 1px solid #9FA5AC;
        float: right;
        margin-top: 40px;
    }
    #analyze >>> .el-progress-bar{
        padding-right: 60px;
    }
    #analyze >>> .el-progress-bar__outer{
        border-radius: 2px;
    }
    #analyze >>> .el-progress-bar__inner{
        border-radius: 2px;
    }
    #analyze .li_span {
        color: #909399;
        font-size: 12px;
        display: inline-block;
        width: 70px;
        height: 100%;
        vertical-align:top
    }
    #analyze .li {
        padding: 10px 0;
    }
    #analyze .li_spanR{
        color: #909399;
        font-size: 12px;
        display: inline-block;
        width: calc(100% - 80px);
        vertical-align:top
    }
    #analyze >>> .el-rate__icon{
        border-radius: 5px;
        overflow: hidden;
    }
    #analyze >>> .el-rate__item{
        width: 18px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/components/analyze/analyze.vue